import type { GetFillColor } from './types';

const getFillColor: GetFillColor = ({ colorMap, percent }) => {
    const matchingThreshold = Object.keys(colorMap)
        .map(Number)
        .filter(threshold => threshold <= percent)
        .sort((first, second) => first - second)
        .pop();

    return matchingThreshold === undefined ? undefined : colorMap[matchingThreshold];
};

export default getFillColor;
